import React from 'react';

const roles = [
  {
    title: 'Senior Tax Strategist',
    location: 'Remote / NYC',
    summary: 'Lead multi-entity tax plans with CPA oversight.',
  },
  {
    title: 'Advisor Partnership Lead',
    location: 'Hybrid',
    summary: 'Build referral programs for wealth managers and RIAs.',
  },
  {
    title: 'Implementation Analyst',
    location: 'Charlotte, NC',
    summary: 'Coordinate documentation, engineering studies, and compliance checklists.',
  },
];

export default function Careers() {
  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-8">
        <header className="space-y-3">
          <p className="text-xs uppercase tracking-[0.6em] text-gray-400">Careers</p>
          <h1 className="text-4xl font-bold text-charcoal">Join the team</h1>
          <p className="text-gray-600">
            We hire experienced tax professionals who value compliance, transparency, and partner relationships. Equity and benefits included for full-time roles.
          </p>
        </header>

        <div className="space-y-6">
          {roles.map((role) => (
            <article key={role.title} className="rounded-3xl border border-gray-200 bg-gray-warm/70 p-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-semibold text-charcoal">{role.title}</h2>
                <span className="text-sm text-gray-500">{role.location}</span>
              </div>
              <p className="mt-3 text-gray-600">{role.summary}</p>
              <button className="mt-4 rounded-full border border-primary px-4 py-2 text-sm font-semibold text-primary">
                Apply by email
              </button>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
